import { useEffect } from 'react';
import { lookup } from 'mime-types';
import { Helmet, HelmetProvider } from 'react-helmet-async';

import { useLanguage } from '@components/Language';
import useHotelChainSlug from '@hooks/useHotelChainSlug';
import { useGetHotelChain } from '@spazious/react-booking-engine';

export type AppHelmetProviderProps = {
  children?: React.ReactNode;
  basename?: string;
};
export const AppHelmetProvider: React.FC<AppHelmetProviderProps> = ({ children, basename }) => {
  const { locale } = useLanguage();
  const hotelChainSlug = useHotelChainSlug();

  const { data } = useGetHotelChain({
    variables: {
      slug: hotelChainSlug,
    },
    // TODO: Remove this skip and manage ad devTools level
    skip: hotelChainSlug === 'localhost',
  });
  const href: string = (data?.data.attributes?.favicon as any) ?? 'favicon.ico';

  useEffect(() => {
    const favicon = document.querySelector('link[rel="icon"]');
    favicon?.setAttribute('href', href);
    favicon?.setAttribute('type', lookup(href) || 'image/x-icon');
  }, [href]);

  return (
    <HelmetProvider>
      <Helmet defaultTitle="Spazious" titleTemplate="Spazious | %s">
        <html lang={locale} />
        <base href={basename} />
      </Helmet>

      {children}
    </HelmetProvider>
  );
};

export default AppHelmetProvider;
